import script from "./AverageBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AverageBar.vue?vue&type=script&setup=true&lang=js"

import "./AverageBar.vue?vue&type=style&index=0&id=0b319aa8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b319aa8"]])

export default __exports__